<template>
  <div class="container-tips container-general">
    <section-title-after title="Tips & Tricks"></section-title-after>

    <div v-if="hasCustomContent" class="content-tips" v-html="customTricksGeneric"></div>

    <div v-else>
      <div class="content-tips" v-if="type === 'ruote-classiche'">
        <div class="content-tips-list" v-html="classicTips"></div>
      </div>
      <div class="content-tips">
        <div class="title-tips">
          Consigli utili per vendere a privati
        </div>
        <div class="content-tips-list" v-html="defaultTips"></div>
      </div>

      <div class="content-tips">
        <div class="title-tips">
          Consigli utili per vendere ad un professionista (permuta)
        </div>
        <div class="content-tips-list" v-html="defaultProfessionalTips"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TipsTricks',
  props: {
    type: {
      type: String,
      required: true,
    },
    customTricksGeneric: {
      type: String,
      default: '',
    },
  },
  computed: {
    hasCustomContent() {
      const plain = this.customTricksGeneric.replace(/<[^>]+>/g, '').trim();
      // Se il contenuto è vuoto oppure equivale a "<p><br></p>" (eventualmente con spazi) lo consideriamo vuoto
      return (
        plain !== '' && this.customTricksGeneric.replace(/\s/g, '').toLowerCase() !== '<p><br></p>'
      );
    },
    defaultTips() {
      return `
          <ul>
            <li>Accertati di avere tutti i documenti necessari per il passaggio di proprietà (certificato di proprietà e libretto di circolazione)</li>
            <li>Presenta al meglio la tua moto, alcuni interventi estetici che richiedono poca spesa, ma rendono molto più desiderabile il veicolo</li>
            <li>È preferibile che tutti gli interventi di riparazione, manutenzione e controllo di qualità siano documentati (libretto dei tagliandi e fatture degli interventi); questo renderà la trattativa più semplice</li>
            <li>Gli pneumatici devono avere il battistrada almeno al limite di legge (per la nostra quotazione almeno al 50%)</li>
            <li>Ricordati di segnalare la presenza di tutte le dotazioni accessorie.</li>
            <li>Gli equipaggiamenti opzionali, anche se non valorizzati nella quotazione, possono rendere più interessante il veicolo al compratore. Indicali sempre.</li>
            <li>Prima di firmare il passaggio di proprietà accertati dell’effettiva solvibilità del pagamento, se non conosci il cliente</li>
          </ul>
        `;
    },
    defaultProfessionalTips() {
      return `
          <ul>
            <li>La quotazione di ritiro sconta, oltre i costi gestionali e finanziari che il concessionario o rivenditore deve sostenere, anche i rischi d’impresa e il legittimo guadagno dell’imprenditore</li>
            <li>In fase di contrattazione, fai chiaramente indicare lo sconto della moto nuova e la quotazione del tuo usato, solo così potrai confrontare diverse offerte</li>
            <li>Accertati di avere tutti i documenti per il passaggio di proprietà (certificato di proprietà e libretto di circolazione)</li>
            <li>In fase contrattuale non nascondere alcun problema o danno presente sul veicolo, il concessionario in fase di effettivo ritiro della moto potrebbe riconsiderare la valutazione</li>
            <li>Ricordati che la seconda chiave è una dotazione obbligatoria, è necessario consegnarla per non doversi accollare il costo</li>
          </ul>
        `;
    },
    classicTips() {
      return `
          <ul>
            <li>Il valore di mercato di una moto storica può essere influenzato dal fatto che sia appartenuta a un personaggio famoso, soprattutto se legato al mondo del motociclismo.</li>
            <li>Il valore di una perizia assicurativa permette di dormire sonni tranquilli in caso di incidente, perché l’assicurazione rimborsa i danni al 100% sulla base della documentazione peritale.</li>
            <li>L’esenzione dal bollo si applica, per ora, solo alle moto che hanno superato i 30 anni dalla costruzione. In Lombardia, Emilia-Romagna e in alcune province autonome, l’esenzione è prevista anche per le ultraventennali.</li>
            <li>Per i modelli con meno di 20 anni – e talvolta anche per alcune moto di età inferiore ai 30 anni – non sono molte le compagnie assicurative che offrono polizze agevolate.</li>
            <li>Il mercato delle youngtimer in Italia ha valori di mercato calmierati rispetto a quanto avviene in altri Paesi europei (in particolare Germania e Olanda).</li>
            <li>Attenzione alle moto tra i 20 e i 30 anni: l’introduzione dell’elettronica può complicare la manutenzione. I ricambi non sempre si trovano facilmente, i costi possono essere elevati e i riparatori specializzati sono pochi. </li>
            <li>Un restauro completo sulle moto tra i 20 e i 30 anni raramente è giustificato, per questo, in genere, i collezionisti cercano esemplari ben conservati.</li>
            <li>Il ripristino degli elementi estetici può rappresentare una difficoltà: le grafiche originali, le selle o le plastiche non sempre sono facilmente reperibili, e la qualità dei materiali dell’epoca può porre ulteriori limiti.</li>
          </ul>
        `;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/TipsTricks.vue